import { IFlexPanel } from '@bimser/components';
import { createSyncAction } from '@bimser/core';
import * as ActionTypesMain from './actionTypes';
import { FlexPanelFactoryFromJS } from '../entities/FlexPanelFactory';

export default function clickMaximizeFlexPanelAction(args: IFlexPanel) {
	const payload = FlexPanelFactoryFromJS(args);

	const action = createSyncAction(ActionTypesMain.CLICK_MAXIMIZE_FLEX_PANEL, payload);

	return action;
}
